import React, { useState, useEffect } from "react";
import Modal from "./../../components/modal/modal";
import { useDispatch } from "react-redux";
import {
  addStage,
  updateStage,
} from "../../actions/project-management.action";
import {
  sectionFields,
  viewDataStageFields,
} from "./../../constants/fields.constant";
import "./scss/project-management.scss";
import ViewStage from "./view-stage";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploader from "./../../components/file-uploader";
import _ from "lodash";
import { errorSnackBar } from '../../actions/common.action'
import { fileValidator } from "../../util/validators/file";
import { ValidateField } from "src/util/validators";
import CustomInput from "src/components/inputs/new-input";
import TextAreaInput from "src/components/inputs/textarea-input";
import idx from "idx";

const AddStage = ({ open, dialogClose, projectId, getStages, stageId: propStageId, userAccessControl, totalStageCost, addStage: propAddStage, parentStageId, nestedStageId, stageTotals, selectedSections }) => {
  const dispatch = useDispatch();
  const [fields, setFields] = useState(JSON.parse(JSON.stringify(sectionFields)));
  const [viewData, setViewData] = useState(JSON.parse(JSON.stringify(viewDataStageFields)));
  const [viewMode, setViewMode] = useState(false);
  const [stageId, setStageId] = useState(null);

  useEffect(() => {
    if (propStageId !== stageId && !propAddStage) {

      if (propStageId) {
        const name = idx(selectedSections, _ => _.name) || '';
        const description = idx(selectedSections, _ => _.description) || '';
        const totalCost = idx(stageTotals, _ => _[propStageId].totalSaleAmount) || 0;
        const taskCount = idx(stageTotals, _ => _[propStageId].taskCount) || 0;

        const viewData = {
          name: name,
          description: description,
          totalCost: totalCost.toFixed(2),
          totalTasks: taskCount,
        };
        setViewData(viewData);
        setViewMode(true);
        const updatedFields = { ...fields };
        updatedFields.sectionName.value = name;
        updatedFields.description.value = description;
        updatedFields.attachments.attachmentArr = [];
        selectedSections.attachment && selectedSections.attachment.forEach((attach) => {
          if (_.isString(attach)) updatedFields.attachments.attachmentArr.push(JSON.parse(attach));
          else updatedFields.attachments.attachmentArr.push(attach);
        });
        setFields(updatedFields);
      }
      setStageId(propStageId);
    }
  }, [propStageId, stageId, dispatch, totalStageCost]);


  const inputChangeHandler = (e, fieldName = "") => {
    const updatedFields = { ...fields };
    let isValid = true;
    if (e.target.type === "checkbox") {
      updatedFields[e.target.name].value = e.target.checked;
    } else if (e.target.type === "file") {
      Array.from(e.target.files).map(file => {
        const fileValidation = fileValidator({ file });
        const { validFileSize, validFileType, error } = fileValidation
        if (!validFileSize.valid && !error) {
          isValid = false
          dispatch(errorSnackBar(validFileSize.error))
        }
        else if (!validFileType.valid && !error) {
          isValid = false
          dispatch(errorSnackBar(validFileType.error))
        } else if (error) {
          isValid = false
          dispatch(errorSnackBar(error.error))
        } else updatedFields[e.target.name].value.push(file);
      })
      if (!isValid) return
    } else {
      updatedFields[e.target.name].value = e.target.value;
    }
    updatedFields[e.target.name].touched = true;
    updatedFields[e.target.name].error = false;
    updatedFields[e.target.name].valid = true;
    setFields(updatedFields);
  };

  const submitHandler = () => {
    const formData = new FormData();
    [fields.sectionName, fields.description].forEach((field) => {
      const { error, valid } = ValidateField({ value: field.value, validation: field.validation });
      field.error = error;
      field.valid = valid;
      field.touched = true;
    });
    if (!fields.sectionName.valid || !fields.description.valid) {
      setFields(prev => ({
        ...prev,
        stageName: {
          ...prev.sectionName,
          error: fields.sectionName.error,
          touched: true,
          valid: fields.sectionName.valid,
        },
        description: {
          ...prev.description,
          error: fields.description.error,
          touched: true,
          valid: fields.description.valid,
        },
      }));
      return;
    }
    formData.set("name", fields.sectionName.value);
    formData.set("description", fields.description.value);
    formData.set("parentStageId", parentStageId || null);
    formData.set("stageId", propStageId || null);
    formData.set("nestedStageId", nestedStageId || null);

    for (var i = 0; i < fields.attachments.attachmentArr.length; i++) {
      formData.append("attachment[]", JSON.stringify(fields.attachments.attachmentArr[i]));
    }
    for (var x = 0; x < fields.attachments.value.length; x++) {
      formData.append("attachment", fields.attachments.value[x]);
    }

    if (!stageId) {
      dispatch(addStage(formData, projectId)).then((res) => {
        getStages();
        dialogClose();
      }).catch(e => console.error(e));
    } else {
      dispatch(updateStage(formData, stageId)).then((res) => {
        getStages();
        dialogClose();
      }).catch(e => console.error(e));
    }
  };

  const editHandler = () => {
    setViewMode(false);
  };

  const handleDialogClose = () => {
    setFields(JSON.parse(JSON.stringify(sectionFields)));
    setViewData(JSON.parse(JSON.stringify(viewDataStageFields)));
    setViewMode(false);
    setStageId(null);
    dialogClose();
  };

  const removeFile = (index, type) => {
    const updatedFields = { ...fields };
    if (type === "new") {
      const data = [];
      for (var x = 0; x < updatedFields.attachments.value.length; x++) {
        if (x !== index) data.push(updatedFields.attachments.value[x]);
      }
      updatedFields.attachments.value = data;
    }
    if (type === "old") {
      const data = updatedFields.attachments.attachmentArr.filter((doc, i) => i !== index);
      updatedFields.attachments.attachmentArr = data;
    }
    setFields(updatedFields);
  };

  let modalHeading = parentStageId ? "Create Sub Section" : "Create Section";
  if (stageId) modalHeading = parentStageId ? "Edit Sub-Section" : "Edit Section";
  if (viewMode) modalHeading = parentStageId ? "View Sub-Section" : "View Section";

  const files = [];

  for (var x = 0; x < fields.attachments.value.length; x++) {
    const index = x;
    files.push(
      <div key={x} className="attachedFiles">
        <p style={{ margin: "0 10px 0 0" }}>{fields.attachments.value[x].name}</p>
        <p style={{ margin: "0", cursor: "pointer", float: "right" }} onClick={() => removeFile(index, "new")}>
          <DeleteIcon />
        </p>
      </div>
    );
  }

  const attachments = fields.attachments.attachmentArr.map((doc, i) => (
    <div key={i} className="attachedFiles">
      <p style={{ margin: "0 10px 0 0" }}>
        <a href={doc?.url} rel="noopener noreferrer" target="_blank">{doc.name}</a>
      </p>
      <p style={{ margin: "0", cursor: "pointer", float: "right" }} onClick={() => removeFile(i, "old")}>
        <DeleteIcon />
      </p>
    </div>
  ));

  return (
    <Modal
      open={open}
      onClose={handleDialogClose}
      fullWidth={true}
      maxWidth="md"
      modalHeading={modalHeading}
      modalSaveTxt={!viewMode && "Save"}
      modalCloseTxt={!viewMode && "Cancel"}
      onClick={submitHandler}
      showActionBtn
      savebtnClass="createBtn"
      primary
    >
      <div className="addStageContainer">
        {!viewMode && (
          <>
            <div className="d-flex flex-lg-nowrap flex-md-wrap gap-2 subtaskrow-1">
              <div className="w-100">
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <div className="flex-grow-0 flex-shrink-0 stageLabel">Section Name:</div>
                  <div className="flex-grow-1 flex-shrink-1 ps-2">
                    <CustomInput {...fields.sectionName} onChange={(e) => inputChangeHandler(e)} />
                  </div>
                </div>
                <div className="subtaskrow-1 d-flex flex-wrap gap-2 align-items-center my-2">
                  <div className="flex-grow-0 flex-shrink-0 stageLabel">Description</div>
                  <div className="addStageDesc description flex-grow-1 flex-shrink-1 ps-2">
                    <TextAreaInput {...fields.description} onChange={(e) => inputChangeHandler(e)} />
                  </div>
                </div>
              </div>

              <div className="stageLabel attachFile w-100">
                <div className="d-flex flex-column flex-wrap">
                  <div className="fileupload-section flex-grow-1 flex-shrink-1">
                    <div className="file-section-part pt-0 position-relative h-auto px-0">
                      <div className="file-part">
                        <FileUploader fileHandler={(files) => inputChangeHandler({
                          target: { files, type: "file", name: "attachments" },
                        })} />
                        {/* {attachments.length ? attachments : null} */}
                        <label htmlFor="#file-section"></label>
                      </div>
                      <input type="file" id="file-section"></input>
                    </div>
                  </div>
                  <div className="flex-grow-1 flex-shrink-1">
                    <div className="form-group text-left">
                      <div className="input-block">
                        <label className="input-label">{fields.attachments.label}</label>
                        <p className="m-0 d-flex flex-column doc-info">
                          {files}
                          {attachments.length ? attachments : null}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {viewMode && (
          <ViewStage
            viewData={viewData}
            totalStageCost={totalStageCost}
            editHandler={editHandler}
            userAccessControl={userAccessControl}
            parentStageId={parentStageId}
          />
        )}
      </div>
    </Modal>
  );
};

export default AddStage;